import { Box, withStyles } from '@material-ui/core';

export const HeaderContainer = withStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gridGap: '8px',
    justifyContent: 'space-between',
    width: '100%'
  }
})(Box);

export const ImageContainer = withStyles({
  root: {
    width: 102,
    height: 64,
    display: 'flex',
    justifyContent: 'center'
  }
})(Box);
